var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block col-action-bar"},[_c('div',{staticClass:"sticky-top"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 border-top border-light"},[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Action")]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b99414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DesktopActionBar.vue
// module id = 734
// module chunks = 30